import type { FC } from "react";
import { Button } from "@/components/button";
import { cn } from "@/lib/cn";

type PractitionerActionsProps = {
  profileHref?: string;
  onContact?: () => void;
  className?: string;
  buttonClassName?: string;
};

export const PractitionerActions: FC<PractitionerActionsProps> = ({
  profileHref,
  onContact,
  className,
  buttonClassName,
}) => (
  <div className={cn("flex gap-8", className)}>
    <Button
      size="m"
      onClick={(event) => {
        event.stopPropagation();
        onContact?.();
      }}
      className={cn("w-full flex-1 bg-brand-dark-blue text-neutral-white hover:bg-brand-dark-blue/90", buttonClassName)}
    >
      Contact Me
    </Button>
    {profileHref ? (
      <Button
        size="m"
        variant="secondary-white"
        href={profileHref}
        onClick={(event) => event.stopPropagation()}
        className={cn("w-full flex-1 border-2", buttonClassName)}
      >
        See Profile
      </Button>
    ) : (
      <Button size="m" variant="secondary-white" className={cn("w-full flex-1 border-2", buttonClassName)}>
        See Profile
      </Button>
    )}
  </div>
);
